// https://webpack.js.org/guides/public-path/#on-the-fly
// In a production web build this variable is set by django when it renders the page
// see index.html for more
__webpack_public_path__ = STATIC_URL;
